export default {
    nav: {
        메인:'메인',
        도메인: '도메인',
        아이디: '아이디',
        비밀번호: '비밀번호',
        비밀확인:'비밀확인',
        로그인: '로그인',
        공지사항:'공지사항',
        변동정보:'변동정보',
        이벤트:'이벤트',
        회원관리:'회원관리',
        부본사관리:'부본사관리',
        본사관리:'본사관리',
        마스터관리:'마스터관리',
        대시보드:'대시보드',
        총판관리:'총판관리',
        게임관리:'게임관리',
        알본관리:'알본관리',
        회원별입출금:'회원별입출금',
        총판별입출금:'총판별입출금',
        RACE결과:'RACE결과',
        구매내역RACE:'구매내역(RACE)',
        RACE리스트:'RACE리스트',
        입출금내역:'입출금내역',
        수동충환내역:'수동충환내역',
        손실금RACE:'손실금(RACE)',
        머니로그:'머니로그',
        정산관리:'정산관리',
        출석체크:'출석체크',
        고객센터:'고객센터',
        쪽지관리:'쪽지관리',
        게시판:'게시판',
        팝업관리:'팝업관리',
        답변관리:'답변관리',
        접속리스트:'접속리스트',
        접속로그:'접속로그',
        배팅내역:'배팅내역',
        배팅:'배팅',
        종합로그:'종합로그',
        사이트설정:'사이트설정',
        구매내역파워볼:'구매내역(파워볼)',
        구매내역4조합:'구매내역(4조합)',
        매장관리:'매장관리',
        파워볼결과:'파워볼결과',
        사다리결과:'사다리결과',
        파워볼결과보글:'파워볼결과(보글)',
        사다리결과보글:'사다리결과(보글)',
        API배팅:'API배팅',
        루징정산:'루징정산',
        팝업관리:'팝업관리',
        일자별롤링루징:'일자별롤링&루징',
        알잔액:'알잔액',
        입금내역:'입금내역',
        출금내역:'출금내역',
        배팅금액:'배팅금액',
        당첨금액:'당첨금액',
        낙첨금액:'낙첨금액',
        배팅롤링:'배팅롤링',
        정산비율:'정산비율',
        루징금:'루징금',
        루징금카:'루징금(카)',
        루징금슬:'루징금(슬)',
        처리롤링금:'처리롤링금',
        보글롤링:'보글롤링',
        카:'카',
        슬:'슬',
        파:'파',
        배팅한도:'배팅한도',
        딜레이:'딜레이',
        적중한도:'적중한도',
        마지막출금:'마지막출금',
        게임사:'게임사',
        단:'단',
        조:'조',


    },
    msg: {
        확인하시겠습니까:'확인하시겠습니까?',
        취소하시겠습니까:'취소하시겠습니까?',
        처리중하시겠습니까:'처리중하시겠습니까?',
        언어전환:'언어전환',
        아이디닉네임:'아이디(닉네임)',
        추천내역:'추천내역',
        배팅파워:'배팅(파워)',
        머니합계:'머니합계',
        이벤합계:'이벤합계',
        바루징:'바루징',
        슬롤링:'슬롤링',
        파롤링:'파롤링',
        카롤링:'카롤링',
        수동충전:'수동충전',
        슬루징:'슬루징',
        수동환전:'수동환전',
        입금출금:'입금-출금',
        문의:"1:1문의",
        금일총입금:'금일총입금',
        금일총출금:'금일총출금',
        데이타삭제:'데이타삭제',
        DATA리셋:'DATA리셋',
        롤링금:'롤링금',
        롤링금카:'롤링금(카)',
        롤링금슬:'롤링금(슬)',
        롤링금파단:'롤링금(파-단)',
        롤링금파조:'롤링금(파-조)',
        문의제목:'문의제목',
        문의내용:'문의내용',
        문의시간:'문의시간',
        적:'적',
        낙:'낙',
        적중:'적중',
        상세보기:'상세보기',
        상세:'상세',
        일시:'일시',
        잔고:'잔고',
        일륜:'일륜',
        일정:'일정',
        일경:'일경',
        한경:'한경',
        일반:'일반',
        신규:'신규',
        한국경마:'한국경마',
        한경삼복:'한경삼복',
        한경쌍승:'한경쌍승',
        한경복연:'한경복연',
        일본경정:'일본경정',
        경정삼복:'경정삼복',
        일본경륜:'일본경륜',
        경륜삼복:'경륜삼복',
        일본경마:'일본경마',
        일경삼복:'일경삼복',
        일경삼쌍:'일경삼쌍',
        비번:'비번',
        숨김:'숨김',
        레벨선택:'레벨선택',
        오늘접속:'오늘접속',
        본사요역:'본사요역',
        아이디를입력하세요: '아이디를입력하세요',
        비밀번호를입력하세요: '비밀번호를입력하세요',
        도메인을입력하세요: '도메인을입력하세요',
        성공적로그인:'성공적로그인',
        블랙:'블랙',
        대기:'대기',
        기본:'기본',
        제목입력:'제목입력',
        받은쪽지함:'받은쪽지함',
        내용:'내용',
        유효기간:'유효기간',
        답변내용:'답변내용',
        답변시간:'답변시간',
        처리중:'처리중',
        완료:'완료',
        보류:'보류',
        유저:'유저',
        답변:'답변',
        수정완료:'수정완료',
        마지막로그인:'마지막로그인',
        마지막입금:'마지막입금',
        IP차단:'IP차단',
        비번수정:'비번수정',
        로그아웃:'로그아웃',
        아이디:'아이디',
        닉네임:'닉네임',
        입금인:'입금인',
        예금주:'예금주',
        핸드폰:'핸드폰',
        입금금액:'입금금액',
        확인시간:'확인시간',
        팅기기:'팅기기',
        매장:'매장',
        가입IP:'가입IP',
        최종IP:'최종IP',
        알본:'알본',
        쪽지:'쪽지',
        가입시:'가입시',
        아웃:'아웃',
        입금시:'입금시',
        로그인전머니:'로그인전머니',
        로그인회수:'로그인회수',
        로그아웃처리:'로그아웃처리',
        정검:'정검',
        모든회원이보유한카슬머니파워머니합계입니다:'모든회원이 보유한 카슬머니+파워머니 합계입니다',
        삭제하시겠습니까:'삭제하시겠습니까?',
        수정하시겠습니까:'수정하시겠습니까?',
        리턴하시겠습니까:'리턴하시겠습니까?',
        아웃하시겠습니까:'아웃하시겠습니까?',
        본사가보유한카슬머니잔액입니다:'본사가 보유한 카슬머니 잔액입니다',
        게임사확인가능:'게임사확인가능',
        최소배팅:'최소배팅',
        최대배팅:'최대배팅',
        회차당토탈최대배팅:'회차당토탈최대배팅',
        리턴:'리턴',
        입력해주세요:'입력해주세요',
        수정:'수정',
        리셋:'리셋',
        취소됨:'취소됨',
        알림:'알림',
        입금:'입금',
        베팅당첨롤링슬:'베팅/당첨/롤링(슬)',
        베팅당첨롤링카:'베팅/당첨/롤링(카)',
        베팅당첨롤링파:'베팅/당첨/롤링(파)',
        출금:'출금',
        카슬:'카% / 슬%',
        출금금액:'출금금액',
        삭제:'삭제',
        레이스배팅:'레이스배팅',
        파워볼배팅:'파워볼배팅',
        취소:'취소',
        이벤트전환:'이벤트전환',
        이벤트지급:'이벤트지급',
        롤링전환:'롤링전환',
        롤링지급:'롤링지급',
        매장롤링:'매장롤링',
        총판롤링:'총판롤링',
        부본사롤링:'부본사롤링',
        회원롤링:'회원롤링',
        알충전:'알충전',
        알환전:'알환전',
        롤링충전:'롤링충전',
        롤링환전:'롤링환전',
        업로드완료:'업로드완료',
        업로드:'업로드',
        입출금:'입출금',
        대중소:'대중소',
        사이트머니카지노머니전환:'사이트머니->카지노머니전환',
        카지노머니:'카지노머니',
        카지노머니사이트머니전환:'카지노머니->사이트머니전환',
        검색타이틀선택하세요:'검색타이틀선택하세요',
        환불하시겠습니까:'환불하시겠습니까?',
        사이트머니:'사이트머니',
        카지노슬롯머니:'카지노슬롯머니',
        사용안함:'사용안함',
        사용:'사용',
        탈퇴:'탈퇴',
        파홀짝:'파홀짝',
        일홀짝:'일홀짝',
        파언오:'파언오',
        일언오:'일언오',
        제목:'제목',
        마스터요역:'마스터요역',
        답변제목:'답변제목',
        전체:'전체',
        금지:'금지',
        보글:'보글',
        경기전:'경기전',
        하위포함:'하위포함',
        비적중:'비적중',
        없음:'없음',
        구매자:'구매자',
        파워볼:'파워볼',
        등록:'등록',
        일반볼조합:'일반볼조합',
        파워볼조합:'파워볼조합',
        파워일반조합:'파워일반조합',
        카슬파루징:'카+슬+파루징',
        적특:'적특',
        모든조합:'모든조합',
        사다리:'사다리',
        동행:'동행',
        회차:'회차',
        총판:'총판',
        부본사:'부본사',
        부본:'부본',
        전금액:'전금액',
        실패:'실패',
        당첨:'당첨',
        베팅당첨:'베팅-당첨',
        보유머니:'보유머니',
        보유이벤트:'보유이벤트',
        마스터생성:'마스터생성',
        환불:'환불',
        슬롯:'슬롯',
        라이브:'라이브',
        확인:'확인',
        정상:'정상',
        차단:'차단',
        추천인:'추천인',
        배당:'배당',
        베팅:'베팅',
        사일:'사일',
        사조:'사조',
        팝업:'팝업',
        내역이1000건이넘습니다1000건아래로검색하신후다운로드해주세요:'내역이1000건이넘습니다1000건아래로검색하신후다운로드해주세요',
        오늘배팅내역만다운가능합니다:'오늘배팅내역만다운가능합니다!!!',
        리셋하시겠습니까:'리셋하시겠습니까?',
        엑셀저장완료:'엑셀저장완료',
        크기보다작아야함:'2MB크기보다작아야함',
        충전:'충전',
        환전:'환전',
        가능:'가능',
        게임머니:'게임머니',
        갱신완료:'갱신완료',
        이벤트머니:'이벤트머니',
        이전롤링:'이전롤링',
        바치기:'바치기%',
        롤링머니:'롤링머니',
        배팅누적:'배팅누적',
        합계:'합계:',
        지급:'지급',
        카지노:'카지노',
        하부아이디:'하부아이디',
        총판또는매장선택해주세요:'총판또는매장선택해주세요',
        회원:'회원',
        조합:'조합',
        파트너:'파트너',
        신청시ip:'신청시ip',
        삭제하시겠습니까복구불가:'삭제하시겠습니까?복구불가!',
        적용하시겠습니까:'적용하시겠습니까?!',
        등록하시겠습니까:'등록하시겠습니까?',
        입금보너스:'입금보너스',
        일반조합:'일반조합-',
        파워조합:'파워조합-',
        파워:'파워',
        적용:'적용',
        비번이일치하지않습니다:'비번이일치하지않습니다',
        지원안됩니다:'지원안됩니다',
        로그인팝업:'로그인 팝업',
        파워머니충전:'파워머니충전',
        파워머니환전:'파워머니환전',
        파워롤링충전:'파워롤링충전',
        파워롤링환전:'파워롤링환전',
        일반회원을매장으로조정입니다:'일반회원을 매장으로 조정입니다.',
        회원아이디:'회원아이디',
        날자:'날자',
        닫기:'닫기',
        보글파조합:'보글파 조합',
        사이트머니:'사이트 머니',
        카지노슬롯머니:'카지노슬롯 머니',
        에서:'에서',
        전환하기:'전환하기',
        카:'카',
        슬:'슬',
        시0:'00시',
        시1:'01시',
        시2:'02시',
        시3:'03시',
        시4:'04시',
        시5:'05시',
        시6:'06시',
        시7:'07시',
         시8:'08시',
        시9:'09시',
        시10:'10시',
        시11:'11시',
        시12:'12시',
        시13:'13시',
        시14:'14시',
        시15:'15시',
        시16:'16시',
        시17:'17시',
        시18:'18시',
        시19:'19시',
        시20:'20시',
        시21:'21시',
        시22:'22시',
        시23:'23시',
        롤링합계:'롤링합계',
        배팅당첨:'배팅-당첨',
        슬당첨:'슬당첨',
        파배팅:'파배팅',
        슬배팅:'슬배팅',
        카당첨:'카당첨',
        파당첨:'파당첨',
        카배팅:'카배팅',
        모든회원이보유한카슬롤링파워롤링합계입니다:'모든회원이 보유한 카슬롤링+파워롤링 합계입니다',
        총판출금:'총판출금',
        배팅차단:'배팅차단',
        파사롤링:'파사롤링',
        롤링파단:'롤링(파-단)',
        롤링파조:'롤링(파-조)',
        가입시코드:'가입시 코드',
        롤링:'롤링',
        롤링카:'롤링(카)',
        롤링슬:'롤링(슬)',
        롤링파:'롤링(파)',
        하부롤링:'하부롤링',
        실지급금:'실지급금',
        루징:'루징',
        수익:'수익',
        총롤링:'총롤링',
        총:'총',
        포인트롤링:'포인트(롤링)',
        카슬머니:'카슬머니',
        카슬머니갱신:'카슬머니갱신',
        카슬롤링:'카슬롤링',
        파워머니:'파워머니',
        파워롤링:'파워롤링',
        접속자:'접속자',
        입금액:'입금액',
        총입금:'총입금',
        출금액:"출금액",
        총출금:'총출금',
        파워볼일반:'파워볼일반',
        파워볼조합:'파워볼조합',
        보글파일반:'보글파일반',
      
        보글사일반:'보글사일반',
        보글사조합:'보글사조합',
        카지노롤링:'카지노롤링',
        슬롯롤링:'슬롯롤링',
        바카라루징:'바카라루징',
        슬롯루징:'슬롯루징',
        가입시간:'가입시간',
        파워볼일반보글:'파워볼 일반(보글)',
        파워볼조합보글:'파워볼 조합(보글)',
        사다리일반보글:'사다리 일반(보글)',
        사다리조합보글:'사다리 조합(보글)',
        충환:'충-환',
        총배팅:'총배팅',
        총배팅카:'총배팅(카)',
        총배팅슬:'총배팅(슬)',
        총배팅파:'총배팅(파)',
        총당첨:'총당첨',
        총당첨카:'총당첨(카)',
        총당첨슬:'총당첨(슬)',
        총당첨파:'총당첨(파)',
        총수수료:'총수수료',
        총수수료카:'총수수료(카)',
        총수수료슬:'총수수료(슬)',
        총수수료파:'총수수료(파)',
        총수익:'총수익',
        총수익카:'총수익(카)',
        총수익슬:'총수익(슬)',
        총수익파:'총수익파',
        등급:'등급:',
        상위:'상위:',
        접속:'접속',
        가입코드:'가입코드',
        본사:'본사',
        가입경로:'가입경로',
        가입일:'가입일',
        레밸:'레밸',
        아이디만입력시해당아이디로만전송:'아이디만 입력 시 해당 아이디로만 전송',
        아이디입력및부본총판매장선택시해당소속회원까지전송:'아이디 입력 및 부본 총판 매장 선택 시 해당 소속 회원까지 전송',
        아이디없이레벨만선택시해당등급에만전송:'아이디 없이 레벨만 선택 시 해당 등급에만 전송',
        레벨:'레벨',
        마스터:'마스터',
        본:'본',
        가입:'가입'


    },
    status:{
        편집:'편집',
        선택:'선택',
        알본선택:'알본선택',
    },
    dateText:{
        최근한주:'최근한주',
        최근한달:'최근한달',
        최근3개월:'최근3개월',

    },
    title:{
        소속회원:'소속회원',
        소속총판:'소속총판',
        회원리스트:'회원리스트',
        소속부본:'소속부본',
    },
    searchText:{
        매장생성:'매장생성',
        회원매장업:'회원->매장업',
        인증코드:'인증코드',
        단폴:'단폴',
        선택환불:'선택환불',
        카슬충전:'카슬충전',
        카슬환전:'카슬환전',
        카슬차액:'카슬차액',
        파워충전:'파워충전',
        파워환전:'파워환전',
        파워차액:'파워차액',
        알충:'알충',
        알환:'알환',
        카슬:'카슬',
        보낸쪽지함:'보낸쪽지함',
        매장선택:'매장선택',
        회원생성:'회원생성',
        머니충환전:'머니충환전',
        노출:'노출',
        게임수량:'게임수량',
        부본사생성:'부본사생성',
        부징금층배팅금당침금배팅롤링손해금루징:'부징금 = (층배팅금 - 당침금- 배팅롤링 - 손해금)*루징%',
        구글OTP:'구글OTP',
        접속회원수:'접속회원수',
        선택삭제:'선택삭제',
        쪽지보내기:'쪽지보내기',
        타이틀선택:'타이틀선택',
        엑셀다운:'엑셀다운',
        키워드:'키워드',
        시작:'시작',
        마감:'마감',
        검색:'검색',
        입금계:'입금계',
        출금계:'출금계',
        차액:'차액',
        알본생성:'알본생성',
        리스트에노출될키워드:'리스트에노출될키워드',
        구분:'구분',
        상태선택:'상태선택',
        구매시간:'구매시간',
        카지노잔액:'카지노잔액',
        날자선택:'날자선택',
        페이지:'페이지',
        불러오기:'불러오기',
        시간선택:'시간선택',
        롤링처리:'롤링처리',
        타입선택:'타입선택',
        본사생성:'본사생성',
        jackpot금액:'jackpot금액:',
        주간출금랭킹Top1ID:'주간 출금랭킹 Top1 ID:',
        주간출금랭킹Top1머니:'주간 출금랭킹 Top1 머니:',
        바카라점검:'바카라점검:',
        슬롯점검:'슬롯점검:',
        원:'원',
        분:'분',
        서비스:'서비스',
        점검중:'점검중',
        서비스점검:'서비스 점검:',
        점검중멘트:'점검중멘트:',
        관리자접속가능아이피:'관리자 접속가능 아이피:',
        환전최소금액:'환전최소금액:',
        회최대환전금액:'1회 최대환전금액:',
        일최대환전금액:'1일 최대환전금액:',
        재환전신청가능시간:'재환전 신청가능 시간:',
        은행계좌:'은행계좌:',
        필수아님:"필수아님",
        입력필수:'입력필수',
        회원가입시추천인:'회원가입시 추천인:',
        회원한줄광고:'회원 한줄광고:',
        총판한줄공지:'총판 한줄공지:',
        가입쪽지제목설정:'가입쪽지 제목 설정:',
        가입쪽지문구설정:'가입쪽지 문구 설정:',
        고객센터가상계좌:'고객센터-가상계좌:',
        고객센터온라인계좌:'고객센터-온라인 계좌:',
        고객센터지인계좌:'고객센터-지인계좌:',
        고객센터요청처리완료:'고객센터-요청처리 완료:',
        고객센터대기멘트:'고객센터-대기멘트:',
        고객센터여신불가:'고객센터-여신불가:',
        고객센터서비스불가:'고객센터-서비스불가:',
        고객센터환전지연:'고객센터-환전 지연:',
        고객센터인터넷불량:'고객센터-인터넷불량:',
        저장:'저장',
        요청:'요청',

        
    },
    tableText:{
        현카슬:'현카슬',
        현롤링:'현롤링',
        현제비번:'현제비번',
        차단하기:'차단하기',
        원인:'원인',
        IP해제:'IP해제',
        총판이름:'총판이름',
        총판생성:'총판생성',
        매장이름:'매장이름',
        처리상태:'처리상태',
        보낸사람:'보낸사람',
        합:'합',
        구매내역:'구매내역',
        바카라배팅당첨:'바카라(배팅-당첨)',
        총판입금:"총판입금",
        관리자입금:'관리자 입금',
        관리자출금:'관리자 출금',
        계좌정보:'계좌정보',
        완료시간:'완료시간',
        이전이벤트머니:'이전이벤트머니',
        이전게임머니:'이전게임머니',
        변동후:'변동후',
        배팅카슬:'배팅(카슬)',
        알충환:'알충환',
        베팅롤링:"베팅롤링",
        변동후롤링:'변동후롤링',
        전용가상:'전용가상',
        추천:'추천',
        주소:'주소',
        변동후머니:'변동후머니',
        보낸내용:'보낸내용',
        보낸시간:'보낸시간',
        읽은시간:'읽은시간',
        마스터아이디:'마스터아이디',
        슷자:'슷자',
        마스터이름:'마스터이름',
        부본사총판매장:'부본사-총판-매장',
        이미지수정:'이미지수정',
        게임아이디:'게임아이디',
        로고:'로고',
        점검:'점검',
        영어타이틀:'영어타이틀',
        한글이름:'한글이름',
        순위:'순위',
        하위총판:'하위총판',
        부본사아이디:'부본사아이디',
        부본사요역:'부본사요역',
        데이타가없습니다:'데이타가없습니다',
        이름:'이름',
        브라우저:'브라우저',
        도메인:'도메인',
        시간:'시간',
        잔액:'잔액',
        머니변동:'머니변동',
        아이피:'아이피',
        변동금액:'변동금액',
        현잔액:'현잔액',
        내역:'내역',
        적중금:'적중금',
        신청시잔액:'신청시잔액',
        오늘입금:'오늘입금',
        신청시간:'신청시간',
        사용자암호:'사용자암호',
        알본사선택:'알본사선택',
        본사선택:'본사선택',
        부본사선택:'부본사선택',
        상위부본선택:'상위부본선택',
        부본사이름:'부본사이름',
        마스터선택:'마스터선택',
        api매장ID:'api매장ID',
        api매장PW:'api매장PW',
        하위회원:'하위회원',
        보유알:'보유알',
        충환전:'충환전',
        연락처:'연락처',
        하위본사:'하위본사',
        총판선택:'총판선택',
        상태:'상태',
        수정:'수정',
        추가:'추가',
       부본사총판추천인:'부본사/총판/추천인',

        출금비번:'출금비번',
        회수가능:'회수가능',
        은행명:'은행명',
        계좌번호:'계좌번호',
        예금주:'예금주',
        회도메인:'회도메인',
        파도메인:'파도메인',
        타입:'타입',
        금액:'금액',
        처리시간:'처리시간',
        메모:'메모',
        만원:'만원',
        정정:'정정',
        알본사:'알본사',
        위치:'위치',
        추가시간:'추가시간',
        유효기간:'유효기간',
        부본사총판매장:'부본사/총판/매장',
        게임:'게임',
        날짜:'날짜',
        슬롯배팅:'슬롯배팅',
        슬롯당첨:'슬롯당첨',
        슬롯배팅당첨:'슬롯(배팅-당첨)',
        포인트출금:'포인트 출금',
        포인트입금:'포인트 입금',
        바카라배팅:'바카라배팅',
        바카라당첨:'바카라당첨',
        당첨금:'당첨금',
        배팅금:'배팅금',
        게임명:'게임명',
        공급사:'공급사',
        부본총판매장:'부본-총판-매장',
        조회:'조회',
        이전잔액:'이전잔액',
        상위마스터:'상위마스터',
        본사이름:'본사이름',
        하위부본:'하위부본',
        본사아이디:'본사아이디',
        체크타임:'체크타임',
        상위:'상위',
    },


}
   



// WEBPACK FOOTER //
// ./src/vueI18n/en.js